export default {"src":"/_next/static/media/Pre-Sale.c9d0c201.svg","height":92,"width":91};